import { Component, OnInit, AfterViewInit, ChangeDetectorRef, SimpleChanges, DoCheck } from '@angular/core';
//import { PrimeNGConfig } from 'primeng/api';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MessageService } from 'primeng/api';
import { timeout } from 'rxjs/operators';
import { StorageService } from 'src/app/shared/service/storage/storage.service';
import { AuthService, CommonService, NavigationService } from './shared/service';
import moment from 'moment';
import { AppRoutes } from './shared/lib/api-constant';
import { AuthService as Auth0Service, IdToken } from '@auth0/auth0-angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone :false
})
export class AppComponent implements OnInit, AfterViewInit {

    checkCount = 0;
    topbarTheme = 'dark';

    menuTheme = 'dark';

    layoutMode = 'light';

    menuMode = 'horizontal';

    isRTL = false;

    inputStyle = 'outlined';

    ripple: boolean = true;
    isRefresh: boolean; //For US 8229

    

    constructor(
      //  private primengConfig: PrimeNGConfig,
        private spinner: SpinnerVisibilityService,
        public storageService: StorageService,
        private commonService: CommonService,
        private navigationService: NavigationService,
        public auth0Service: Auth0Service,
    ) {
        //For US 8229
        this.storageService.$isRefreshCalled.subscribe((data: any) => {
            this.isRefresh = data.flag;
        })
        this.auth0Service.idTokenClaims$.subscribe((res: IdToken|any) => {
            if (res) {
                this.storageService.setItem('token', res.__raw);
                this.auth0Service.user$.subscribe((profile) => {
                    this.storageService.setItem('signinUser', profile);
                  //  this.bdpAuthService.updateUser(profile);
                    
                })
            }
        })
    }


    ngOnInit() {
        // this.clearTabOnNewTab();
       // this.primengConfig.ripple = true;
        this.spinner.show();
        this.spinner.hide();
            
        
        /**
         * Lifecycle hook that is called after data-bound properties of a directive are initialized.
         * Initializes PrimeNG ripple effect and manages the spinner visibility.
         * Temporarily bypasses authentication by directly setting and retrieving a token from storage.
         * 
         * @remarks
         * - `this.clearTabOnNewTab()` is commented out and might be used for clearing tabs on new tab creation.
         * - `this.authService.sessionSchedule()` is commented out and might be used for scheduling session activities.
         * 
         * @returns void
         */

        //This is o be handled in auth service.
    
        //this.storageService.setItem("token", "agsyvsdvsdyydwgdewydgwydgwygdwudsddasasasasas");
        // this.commonService.navigateRoute({
        //     route: AppRoutes.Manager.HOME,
        //     type: 'User',
        //   });
        let token = this.storageService.getItem('token')
        if (token) {
            // this.authService.sessionSchedule();
        }
    }

    // clearTabOnNewTab() {
    //     var auth = this.authService;
    //     var localStorage = this.storageService;
    //     function clearStorage() {
    //         let session = sessionStorage.getItem('ref');
    //         let token = localStorage.getItem('token')
    //         let directLinkLogin = localStorage.getItem('directLinkLogin');
    //         let redirectFromRiskMonitor = localStorage.getItem('riskMonitorRedirect');
    //         if (redirectFromRiskMonitor) {
    //             localStorage.removeItem('riskMonitorRedirect');
    //         }
    //         else if (!directLinkLogin) {
    //             if (session == null && token) {
    //                 auth.logout();
    //             }
    //             sessionStorage.setItem('ref', '1');
    //         }
    //     }
    //     window.addEventListener('load', clearStorage);
    // }
    ngAfterViewInit() {
        // this.messageService.add({
        //     key: 'c',
        //     sticky: true,
        //     severity: 'warn',
        //     summary: 'Load previous session ?',
        // });
        // setTimeout(() => {
        //     this.hideDialog();
        // }, 10000);
        // this.ref.detectChanges();
    }

    // loadSession() {
    //     const filters = this.storageService.getItem('filters');
    //     this.filterService.updateFilterSelection(filters);
    //     this.hideDialog();
    // }  

    // ngDoCheck(): void {
    //     this.checkCount += 1;
    //     if (this.checkCount == 2500) {
    //         AuthService.lastApiCall = moment();
    //         this.checkCount = 0;
    //     }
    // }
}
